import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import {purpose, resetResponse} from '../Redux/Slice/rootSlice';
import {createPatientsRecord} from '../Redux/Thunk/Actions';
import '../styles/Components/AddPatient_form.scss';

function AddPatient_form(props) {
  const purpose1 = useSelector(state => state.counter.purpose);
  const [createUserInfo, setCreateUserInfo] = useState({
    last_name: '',
    first_name: '',
    email: '',
    phonenumber: '',
    birthdate: null,
    age: 0,
    titles: '',
    purpose: purpose1,
    residence: ''
  });
  const [alert, setAlert] = useState(false);
  const [error, setError] = useState(false);
  const [specificError, setSpecificError] = useState([]);
  const [docref, setdocref] = useState(['Source Google', 'Instagram', 'Facebook', 'YouTube', 'Friends', 'Neighbour', 'Relatives', 'Doctor', 'Existing Patient', 'Others']);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [doctorid, setdoctorid] = useState('');
  const excludedKeys = ['email', 'gender', 'birthdate', 'age', 'blood_group', 'doctor_id', 'residence'];
  const areAllUserInfoValid = Object.keys(createUserInfo)
    .filter(key => !excludedKeys.includes(key))
    .every(key => createUserInfo[key] !== '');

  useEffect(() => {
    if (props.patientInfo) {
      const patient = props.patientInfo;
      setCreateUserInfo({
        ...patient,
        dob: patient.dob ? new Date(patient.dob).toISOString().split('T')[0] : null
      });
    }
  }, [props.patientInfo]);

  const closeUserPopup = e => {
    if (alert) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, revert it!'
      }).then(result => {
        if (result.isConfirmed) {
          navigate('/Patients');
          setAlert(false);
          props.setCloseCreatePopup(false);
        }
      });
    } else {
      navigate('/Patients');
      setAlert(false);
      props.setCloseCreatePopup(false);
    }
  };

  const handleSubmit = event => {
    event.preventDefault();
  };

  const handleDobChange = e => {
    const date = e.target.value;
    if (date) {
      const birthDate = new Date(date);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setCreateUserInfo({
        ...createUserInfo,
        birthdate: date,
        age: age.toString()
      });
    } else {
      setCreateUserInfo({
        ...createUserInfo,
        birthdate: null,
        age: ''
      });
    }
  };

  const handleDropChanges = e => {
    dispatch(purpose(e.target.value));
    setAlert(true);
    setCreateUserInfo({
      ...createUserInfo,
      [e.target.name]: e.target.value
    });
    if (e.target.value == 'Fertility') {
      props.setCloseCreatePopup(false);
      props.setCoupleCreatePopUp(true);
    } else {
      props.setCoupleCreatePopUp(false);
      props.setCloseCreatePopup(true);
    }
  };
  // console.log(purpose1);

  const handleNameChange = e => {
    setAlert(true);
    if (e.target.value === '' || !e.target.value.includes(' ')) {
      setCreateUserInfo({
        ...createUserInfo,
        [e.target.name]: e.target.value.toUpperCase()
      });
    }
  };
  const handleEmailChange = e => {
    setAlert(true);

    setCreateUserInfo({
      ...createUserInfo,
      email: e.target.value
    });
  };

  const handleAgeChange = e => {
    setAlert(true);
    if ((e.target.value === '' || !e.target.value.includes(' ')) && e.target.value.length <= 2) {
      setCreateUserInfo({
        ...createUserInfo,
        age: e.target.value
      });
    }
  };

  const handleResidenceChange = e => {
    setAlert(true);
    setCreateUserInfo({
      ...createUserInfo,
      residence: e.target.value
    });
  };

  const handleMobileChange = e => {
    setAlert(true);

    if (e.target.value === '' || !e.target.value.includes(' ')) {
      setCreateUserInfo({
        ...createUserInfo,
        phonenumber: e.target.value
      });
    }
    if (e.target.value.length > 10) {
      setSpecificError({
        ...specificError,
        mobileSpecificError: true
      });
    } else {
      setSpecificError({
        ...specificError,
        mobileSpecificError: false
      });
    }
  };
  const handleDocIdChange = e => {
    setAlert(true);
    console.log(typeof e.target.value);
    // if (e.target.value === "" || !e.target.value.includes(" ")) {
    setdoctorid(e.target.value);
    setCreateUserInfo({
      ...createUserInfo,
      doctor_id: e.target.value
    });
    // }
  };

  const handleCreatePatient = () => {
    console.log(`handleCreatePatient -->`);
    props.loaderchange('true');
    const CreateThunk = async () => {
      props.loaderchange(true);

      if (createUserInfo.email === '') {
        var {email, ...updatedUserInfo} = createUserInfo;
        const addPatient = createPatientsRecord(updatedUserInfo);
        const response = await dispatch(addPatient);
        if (response?.payload?.status?.code === 200) {
          props.setCloseCreatePopup(false);
          props.setUpdate(true);
          props.loaderchange(false);
          dispatch(resetResponse(''));
          Swal.fire({
            title: 'Successful.',
            text: 'Record added successful.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          props.loaderchange('false');
          props.popupalert('true');
          props.popuptext('Network went wrong, Please try after some time.');
          setTimeout(() => {
            props.popupalert('false');
          }, 2000);
          dispatch(resetResponse(''));
        }
      } else {
        const addPatient = createPatientsRecord(createUserInfo);
        const response = await dispatch(addPatient);
        if (response?.payload?.status?.code === 200) {
          props.setCloseCreatePopup(false);
          props.setUpdate(true);
          props.loaderchange(false);
          dispatch(resetResponse(''));
          Swal.fire({
            title: 'Successful.',
            text: 'Record added successful.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          props.loaderchange('false');
        } else {
          props.loaderchange('false');
          props.popupalert('true');
          props.popuptext('Network went wrong, Please try after some time.');
          setTimeout(() => {
            props.popupalert('false');
          }, 2000);
          dispatch(resetResponse(''));
        }
      }
    };
    // console.log(areAllUserInfoValid)
    if (areAllUserInfoValid) {
      CreateThunk();
    } else {
      setError(true);
    }
  };

  return (
    <>
      <div className='adminform'>
        <div class='modal-dialog1' role='document'>
          <div class='modal-content modelContentChanges'>
            <div class='modal-header'>
              <h5 class='modal-title'>Create Patient Record</h5>
              <button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={e => closeUserPopup(e)}>
                <i class='bi bi-x-lg'></i>
              </button>
            </div>
            <div class='modal-body modelBodyChanges' style={{padding: '1rem', width: '920px'}}>
              <form
                onSubmit={handleSubmit}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}>
                <div class='row'>
                  <div class='col-3 title-dropdown'>
                    <label for='titles' class='form-label'>
                      <span style={{color: 'red'}}>*</span>Title
                    </label>
                    <select id='titles' name='titles' value={createUserInfo.titles} onChange={e => handleDropChanges(e)} className='form-select'>
                      <option value='' disabled selected>
                        Select a Title
                      </option>
                      <option value='Mr'>Mr</option>
                      <option value='Mrs'>Mrs</option>
                      <option value='Miss'>Miss</option>
                    </select>

                    {error && createUserInfo.titles == '' && (
                      <p style={{fontSize: '12px', color: 'red'}}>
                        <span>Required Title</span>
                      </p>
                    )}
                  </div>
                  <div class='col-3 title-dropdown'>
                    <label for='purpose' class='form-label'>
                      Purpose
                    </label>
                    <select
                      id='purpose'
                      name='purpose'
                      // value={createUserInfo.purpose}
                      onChange={e => handleDropChanges(e)}
                      className='form-select'>
                      <option value='' disabled selected>
                        Select Purpose
                      </option>
                      <option value='General'>General</option>
                      <option value='AN'>AN</option>
                      <option value='Fertility'>Fertility</option>
                      <option value='Gynecology'>Gynecology</option>
                    </select>
                  </div>
                </div>
                <div class='row'>
                  <div class='col mt-3'>
                    <label for='first_name' class='form-label'>
                      <span style={{color: 'red'}}>*</span>First Name
                    </label>
                    <input
                      type='text'
                      class='form-control inputStyleChange f_name'
                      id='first_name'
                      name='first_name'
                      variant='standard'
                      style={{textTransform: 'uppercase'}}
                      autoComplete='off'
                      value={createUserInfo.first_name}
                      onKeyDown={e => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onChange={e => handleNameChange(e)}
                      placeholder='Enter Patient First Name....'></input>
                    <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo.first_name === '' && <span>Required First Name</span>}</p>
                  </div>

                  <div class='col mt-3'>
                    <label for='last_name' class='form-label'>
                      <span style={{color: 'red'}}>*</span>Last Name
                    </label>
                    <input
                      type='text'
                      class='form-control inputStyleChange l_name'
                      id='last_name'
                      name='last_name'
                      style={{textTransform: 'uppercase'}}
                      autoComplete='off'
                      onChange={e => handleNameChange(e)}
                      // onBlur={handleLastNameBlur}
                      onKeyDown={e => {
                        if (e.which == '32') {
                          e.preventDefault();
                        }
                      }}
                      value={createUserInfo.last_name}
                      placeholder='Enter Patient Last Name....'></input>
                    <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo.last_name == '' && <span>Required Last Name</span>}</p>
                  </div>
                </div>
                <div class='row'>
                  <div class='col mt-3'>
                    <label for='email' class='form-label'>
                      Email
                    </label>
                    <div class='input-group has-validation'>
                      <span
                        class='input-group-text mailIcon inputStyleChange'
                        id='inputGroupPrepend'
                        style={{
                          borderRadius: '6px 0px 0px 6px'
                        }}>
                        @
                      </span>
                      <input
                        type='text'
                        class='form-control inputStyleChange'
                        id='email'
                        aria-describedby='inputGroupPrepend'
                        autoComplete='off'
                        value={createUserInfo.email}
                        name='email'
                        onChange={e => handleEmailChange(e)}
                        placeholder='Enter Patient Mail id....'
                        // onBlur={handleEmailBlur}
                      ></input>
                    </div>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.email == "" && (
                        <span>Required Email</span>
                      )}
                    </p> */}
                  </div>
                  <div class='col mt-3'>
                    <label for='phonenumber' class='form-label'>
                      <span style={{color: 'red'}}>*</span>Whatsapp Mobile Number
                    </label>
                    <input
                      type='phonenumber'
                      class='form-control inputStyleChange'
                      id='phonenumber'
                      name='phonenumber'
                      autoComplete='off'
                      maxLength={10}
                      onChange={e => handleMobileChange(e)}
                      // onBlur={handleMobileBlur}
                      onKeyDown={e => {
                        if (e.which == '32') {
                          e.preventDefault();
                        }
                      }}
                      value={createUserInfo.phonenumber}
                      placeholder='Enter Patient Mobile Number....'></input>
                    <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo.phonenumber == '' && <span>Required Phone number</span>}</p>
                    {specificError.mobileSpecificError && (
                      <p style={{fontSize: '12px', color: 'red'}}>
                        <span>Enter Valid Phone Number.</span>
                      </p>
                    )}
                  </div>
                </div>
                <div class='row'>
                  <div className=' mt-4 col'>
                    <label for='gender' class='form-label'>
                      Gender
                    </label>
                    <select id='gender' name='gender' value={createUserInfo.gender} onChange={handleDropChanges} className='form-select inputStyleChange'>
                      <option value='' disabled selected>
                        Select a Gender
                      </option>
                      <option value='Male'>Male</option>
                      <option value='Female'>Female</option>
                      <option value='Other'>Other</option>
                      <option value='Decline to State'>Decline to State</option>
                    </select>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.gender == "" && (
                        <span>Required Gender</span>
                      )}
                    </p> */}
                  </div>
                  <div class='col mt-4'>
                    <label for='birthdate' class='form-label'>
                      Date of Birth
                    </label>
                    <input
                      type='date'
                      name='birthdate'
                      onChange={handleDobChange}
                      value={createUserInfo.birthdate || ''}
                      className='form-control inputStyleChange'
                      id='birthdate'
                      autoComplete='off'
                      max={new Date().toISOString().split('T')[0]}
                    />
                  </div>
                  <div class='col mt-4'>
                    <label for='age' class='form-label'>
                      Age
                    </label>
                    <input
                      type='number'
                      class='form-control inputStyleChange'
                      id='age'
                      name='age'
                      autoComplete='off'
                      maxLength={2}
                      onChange={e => handleAgeChange(e)}
                      readOnly
                      // onBlur={handleMobileBlur}
                      onKeyDown={e => {
                        if (e.which == '32') {
                          e.preventDefault();
                        }
                      }}
                      value={createUserInfo.age}></input>
                  </div>
                </div>
                <div class='row'>
                  <div class='col mt-3'>
                    <label for='bloodgroup' class='form-label'>
                      Blood Group
                    </label>
                    <select id='bloodgroup' value={createUserInfo.blood_group} name='blood_group' onChange={handleDropChanges} className='form-select inputStyleChange'>
                      <option value='' disabled selected>
                        Select Blood Group
                      </option>
                      <option value='A+'>A+</option>
                      <option value='A-'>A-</option>
                      <option value='B+'>B+</option>
                      <option value='B-'>B-</option>
                      <option value='AB+'>AB+</option>
                      <option value='AB-'>AB-</option>
                      <option value='O+'>O+</option>
                      <option value='O-'>O-</option>
                    </select>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.blood_group == "" && (
                        <span>Blood Group Required.</span>
                      )}
                    </p> */}
                  </div>
                  <div class='col mt-3'>
                    <label for='residence' class='form-label'>
                      Area of residence
                    </label>
                    <input
                      type='text'
                      class='form-control inputStyleChange'
                      id='residence'
                      name='residence'
                      autoComplete='off'
                      onChange={e => handleResidenceChange(e)}
                      onKeyDown={e => {
                        if (e.which == '32') {
                          e.preventDefault();
                        }
                      }}
                      value={createUserInfo.residence}
                      placeholder='Enter Patient Area of residence....'></input>
                  </div>
                  <div class='col mt-3'>
                    <label for='doctor_referral' class='form-label'>
                      Doctor referral
                    </label>
                    {/* <input
                      type="text"
                      class="form-control inputStyleChange"
                      id="doctor_referral"
                      name="doctor_id"
                      autoComplete="off"
                      onChange={(e) => handleDocIdChange(e)}
                      onKeyDown={(e) => {
                        if (e.which == "32") {
                          e.preventDefault();
                        }
                      }}
                      value={createUserInfo.doctor_id}
                      placeholder="Enter Doctor Referral...."

                    ></input> */}
                    <select
                      class='form-control inputStyleChange'
                      id='doctor_referral'
                      name='doctor_id'
                      autoComplete='off'
                      onChange={e => handleDocIdChange(e)}
                      // *need to uncommand the value
                      // value={!docref.includes(doctorid) ? "" : !docref.includes(createUserInfo.doctor_id) ? "Others" : createUserInfo.doctor_id}
                      placeholder='Enter Doctor Referral....'>
                      <option value='' disabled selected>
                        Select Doctor referral
                      </option>
                      {docref.map(ele => {
                        return <option value={ele}>{ele}</option>;
                      })}
                    </select>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.doctor_id == "" && (
                        <span>Required Doctor Referral</span>
                      )}
                    </p> */}
                  </div>
                </div>
                <div className='row'>
                  {doctorid == 'Others' ? (
                    <div class='col-4 mt-3'>
                      <label for='other_doctor_referral' class='form-label'>
                        <span style={{color: 'red'}}>*</span>Others{' '}
                      </label>
                      <input
                        type='text'
                        class='form-control inputStyleChange'
                        id='other_doctor_referral'
                        name='first_name'
                        variant='standard'
                        autoComplete='off'
                        // value={createUserInfo.first_name}
                        // onKeyDown={(e) => {
                        //   if (e.target.value.length === 0 && e.which === 32) {
                        //     e.preventDefault();
                        //   }
                        // }}
                        onChange={e => {
                          setCreateUserInfo({
                            ...createUserInfo,
                            doctor_id: e.target.value
                          });
                        }}
                        placeholder='Enter Doctor referral....'></input>
                      <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo.first_name === '' && <span>Required First Name</span>}</p>
                    </div>
                  ) : doctorid == 'Doctor' ? (
                    <>
                      <div className='col mt-3'>
                        <label for='doctor_name' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Doctor Name{' '}
                        </label>
                        <input
                          type='text'
                          class='form-control inputStyleChange'
                          id='doctor_name'
                          name='doctor_name'
                          onChange={e => handleDropChanges(e)}
                          variant='standard'
                          autoComplete='off'
                          placeholder='Enter Doctor Name'></input>
                      </div>
                      <div className='col mt-3'>
                        <label for='doctor_no' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Doctor phonenumber{' '}
                        </label>
                        <input
                          type='number'
                          class='form-control inputStyleChange'
                          id='doctor_no'
                          name='doctor_no'
                          variant='standard'
                          onChange={e => handleDropChanges(e)}
                          autoComplete='off'
                          placeholder='Enter Doctor Address'></input>
                      </div>
                      <div className='col mt-3'>
                        <label for='doctor_address' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Doctor Address{' '}
                        </label>
                        <textarea
                          type='text'
                          class='form-control inputStyleChange'
                          id='doctor_address'
                          name='doctor_address'
                          onChange={e => handleDropChanges(e)}
                          variant='standard'
                          autoComplete='off'
                          placeholder='Enter Doctor Address'></textarea>
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </div>

                <button type='submit' class='btn btn-primary  create mt-3' onClick={e => handleCreatePatient(e)} disabled={!alert}>
                  Create Patient Record
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddPatient_form;
